import { useRouter } from "next/router";
import { useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useAuthState } from "../contexts/auth/auth.provider";
import {
  CHECK_BLACK_LIST_BY_IAM_ID,
  GET_IAM_STATUS,
  GET_IAM_URL,
} from "../graphql/queries/user";
import config from "../common/config";
import logger from "../../console";
import { setCookie } from "../lib/cookiesHelpers";
import { ErrorModal } from "@/components/error/ssr";

export const DesiredServicesMap = {
  new_listing: "new_listing",
  verify_office: "verify_office",
  agent_agreement: "agent_agreement",
  add_rega_id: "add_rega_id",
  ejar: "ejar",
  daily_rent: "daily_rent",
  register_interest: "register_real_estate_project_interest",
  quick_sale: "quick_sale_offer",
  user_request_offer: "user_request_offer",
  rnpl: "rnpl_application",
};

export function useCheckIamStatus() {
  const token = useAuthState("token");
  const [checkIamStatus, { loading, called }] = useLazyQuery(GET_IAM_STATUS, {
    context: { token },
    skip: !token,
    ssr: false,
    fetchPolicy: "cache-and-network",
  });
  return [
    () => {
      if (!token) return Promise.resolve({});
      return checkIamStatus().then((res) => res.data?.User?.getIAMStatus);
    },
    loading,
    called,
  ];
}

export default function useIam() {
  const { token } = useAuthState();
  const [iamStatus, setIamStatus] = useState(null);
  const [blackListStatus, setBlackListStatus] = useState(undefined);
  const [iamUrl, setIamUrl] = useState();
  const router = useRouter();
  const [checkIamStatus, checkingStatus, calledStatus] = useCheckIamStatus();
  const [isChecked, toggleIsChecked] = useState();

  const [checkBlackListStatus] = useLazyQuery(CHECK_BLACK_LIST_BY_IAM_ID, {
    skip: !token,
    context: { token },
    ssr: false,
    fetchPolicy: "cache-and-network",
    onCompleted: (res) => {
      logger.log("Iam", res.User.checkBlacklistStatusByIamId);
      setBlackListStatus(res.User.checkBlacklistStatusByIamId);
    },
    onError: ErrorModal.handle,
  });

  useEffect(() => {
    if (calledStatus && !checkingStatus) toggleIsChecked(true);
  }, [checkingStatus, calledStatus]);

  const [getIamUrl] = useLazyQuery(GET_IAM_URL, {
    context: { token },
    skip: !token || !!iamStatus?.id,
    ssr: false,
    notifyOnNetworkStatusChange: true,
    onCompleted: (res) => {
      logger.log("REST", res);
      if (res?.User?.getIAMUrl) router.push(res?.User?.getIAMUrl);
      setIamUrl(res?.User?.getIAMUrl);
    },
    onError: ErrorModal.handle,
  });

  function redirectToIam({ url, desiredListing } = {}) {
    logger.log(`${config.AQAR_WEB}${router.asPath}${url || ""}`);
    getIamUrl({
      variables: {
        redirect_url: `${config.AQAR_WEB}${url || router.asPath}`,
        desired_service: desiredListing,
      },
    });
  }

  useEffect(() => {
    checkIamStatus().then((status) => {
      logger.log("Iam", status);
      if (status) {
        logger.log("Ok", status);
        setIamStatus(status);
        setCookie("user_iam_verified", JSON.stringify(!!status.id || ""));
      }
    });
  }, []);

  return {
    checkingStatus,
    checkIamStatus,
    isChecked,
    redirectToIam,
    checkBlackListStatus,
    isBlackList: (iam_id) =>
      checkBlackListStatus({ variables: { iam_id } }).then(
        (res) => res.data.User.checkBlacklistStatusByIamId,
      ),
    iamStatus,
    iamUrl,
    blackListStatus,
  };
}
